import { noop } from '@capsicum/common';
import { useInfoModal, useRouter } from '@capsicum/common-web';
import { UnstakePledgeReviewAtom } from '@capsicum/socios-core';
import { useSetAtom } from 'jotai';

export const useWCPledgeCancelModal = (
	unstakeInfo: {
		chzAmount: string;
		ftName: string;
		teamFlagUrl: string;
		teamId: string;
		teamName: string;
	},
	cancelPledgeModalTexts: { primaryButtonText: string; secondaryButtonText: string; subtitle: string; title: string }
) => {
	const { showInfoModal } = useInfoModal();
	const router = useRouter();
	const setUnstakeItem = useSetAtom(UnstakePledgeReviewAtom);

	const redirectToUnstakePledge = () => {
		setUnstakeItem({
			...unstakeInfo
		});
		router.push('/locker-room-internationals/unstake');
	};

	const showCancelPledgeModal = () => {
		showInfoModal({
			buttonOnHandlers: {
				onPrimaryButtonHandler: () => noop(),
				onSecondaryButtonHandler: redirectToUnstakePledge,
				primaryInvokeOnDismiss: true,
				secondaryInvokeOnDismiss: true
			},
			buttonTexts: {
				primaryButtonText: cancelPledgeModalTexts.primaryButtonText,
				secondaryButtonText: cancelPledgeModalTexts.secondaryButtonText
			},
			image: 'warning',
			isClosable: true,
			onDismiss: () => noop(),
			subtitle: cancelPledgeModalTexts.subtitle,
			testID: `cancel-pledge-modal-${unstakeInfo?.teamName.toLowerCase()}`,
			title: cancelPledgeModalTexts.title,
			variant: 'confirm'
		});
	};

	return {
		showCancelPledgeModal
	};
};
